import React from 'react';
import { notify } from '../components/CustomToast';

const ToastDemo = () => {
    return (
        <div style={{ padding: '80px 20px', display: 'flex', gap: '40px', flexDirection: 'column', alignItems: 'center', backgroundColor: '#f9fafb', minHeight: '100vh', fontFamily: 'Montserrat, sans-serif' }}>
            <div style={{ textAlign: 'center' }}>
                <h1 className="ui-font-32" style={{ color: '#111827', marginBottom: '10px' }}>Toast Notification System</h1>
                <p className="ui-font-18" style={{ color: '#6b7280' }}>Visual and behavioral match for the design requirements</p>
            </div>

            <div style={{ display: 'flex', gap: '20px' }}>
                <button className="ui-font-16"
                    onClick={() => notify('success', 'Project Updated!', 'Changes saved successfully.')}
                    style={{ padding: '14px 28px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', transition: 'transform 0.2s', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}
                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                >
                    Success Toast
                </button>
                <button className="ui-font-16"
                    onClick={() => notify('error', 'Project deleted!', 'Project deleted successfully.')}
                    style={{ padding: '14px 28px', backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', transition: 'transform 0.2s', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}
                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                >
                    Error Toast
                </button>
            </div>

            <div style={{ marginTop: '40px', maxWidth: '600px', backgroundColor: 'white', padding: '30px', borderRadius: '16px', border: '1px solid #e5e7eb' }}>
                <h3 style={{ marginBottom: '15px' }}>Usage Example:</h3>
                <code className="ui-font-14" style={{ display: 'block', backgroundColor: '#f3f4f6', padding: '15px', borderRadius: '8px' }}>
                    import {'{ notify }'} from '../components/CustomToast';<br /><br />
          // Trigger Success<br />
                    notify('success', 'Title', 'Optional message');<br /><br />
          // Trigger Error<br />
                    notify('error', 'Title', 'Optional message');
                </code>
            </div>
        </div>
    );
};

export default ToastDemo;
